module.exports = __webpack_public_path__ + "img/tht.37d18ab8.jpg";